module.exports = __webpack_public_path__ + "img/6.95a8b73f.png";